import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Shield, X } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CookieBanner() {
  const { language } = useLanguage();
  const [show, setShow] = useState(false);
  const isFr = language === 'fr';

  useEffect(() => {
    const accepted = localStorage.getItem('cookies_accepted');
    if (!accepted) setShow(true);
  }, []);

  const accept = () => {
    localStorage.setItem('cookies_accepted', 'true');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-0" data-testid="cookie-banner">
      <div className="max-w-4xl mx-auto md:mb-4">
        <div className="bg-slate-900 text-white rounded-xl shadow-2xl px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <Shield className="w-5 h-5 text-blue-400 shrink-0 mt-0.5 sm:mt-0" />
          <div className="flex-1 text-sm leading-relaxed">
            {isFr
              ? <>Ce site utilise uniquement des <strong>cookies essentiels</strong> pour l'authentification. Aucun cookie publicitaire. <Link to="/legal" className="underline text-blue-400 hover:text-blue-300">En savoir plus</Link></>
              : <>This site only uses <strong>essential cookies</strong> for authentication. No advertising cookies. <Link to="/legal" className="underline text-blue-400 hover:text-blue-300">Learn more</Link></>
            }
          </div>
          <div className="flex items-center gap-2 shrink-0">
            <Button size="sm" onClick={accept} className="bg-blue-600 hover:bg-blue-700 text-white text-xs" data-testid="cookie-accept-btn">
              {isFr ? 'Accepter' : 'Accept'}
            </Button>
            <button onClick={accept} className="text-slate-400 hover:text-white p-1" data-testid="cookie-close-btn">
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
